// Core
import React, { useRef, useState } from "react";
import Select, { components } from "react-select";

// Styles
import "./style.scss";

// Svg
import closeIcon from "../../Assets/Images/closeIcon.svg";

const CustomSelect = ({
  options,
  onChange,
  value,
  placeholder,
  customStyles,
  isMulti = false,
  isSearchable,
  isClearable,
  label,
  required = false,
  labelStyle = {},
  name,
  defaultBorderColor = "#79747E",
  defaultBorderWidth = "1.5px",
  height = "56px",
  defaultValue,
  isNewCompanyName = false,
  handleAddCompanyName,
  isDisabled = false,
  typedValue,
  updateIsCompanyName,
}) => {

  const selectRef = useRef(null);

  const defaultStyles = {
    control: (provided, state) => ({
      ...provided,
      border: `${defaultBorderWidth} solid ${defaultBorderColor}`,
      borderRadius: "4px",
      padding: "4px",
      boxShadow: "none",
      minHeight: "56px",
      height: height,
      cursor: state.isDisabled ? "not-allowed" : "pointer",
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected
        ? "#1F2155"
        : state.isFocused
          ? "#e9ecef"
          : "#fff",
      color: state.isSelected ? "#fff" : "#000",
      padding: 10,
      "&:hover": {
        backgroundColor: state.isSelected
          ? "#1F2155"
          : state.isFocused
            ? "#e9ecef"
            : "#fff",
        color: state.isSelected ? "#fff" : "#000",
      },
    }),
    singleValue: (provided) => ({
      ...provided,
      color: "#000000",
    }),
    multiValue: (provided) => ({
      display: "none",
    }),
    indicatorSeparator: () => ({
      display: "none",
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      color: "#121212",
      padding: "0 8px",
    }),
  };

  const CustomMenuList = (props) => {
    return (
      <>
        <components.MenuList {...props}>{props.children}</components.MenuList>
        {isNewCompanyName && typedValue && typeof typedValue === "string" && (
          <div
            style={{
              padding: "10px",
              textAlign: "center",
              color: "#1F2155",
              fontWeight: 600,
              cursor: "pointer",
              borderTop: "1px solid #ddd",
            }}
            onClick={() => {
              if (handleAddCompanyName) {
                handleAddCompanyName({ label: typedValue });
              }
              selectRef.current.blur();
              setTimeout(() => selectRef.current.focus(), 150);
            }}
          >
            + Add New Company
          </div>
        )}
      </>
    );
  };

  // Function to handle removal of selected value
  const handleRemove = (optionToRemove) => {
    const newValue = value.filter((val) => val.value !== optionToRemove.value);
    onChange(newValue);
  };

  const handleInputChange = (inputValue, { action }) => {
    if (action !== "input-change") return;

    if (updateIsCompanyName) {
      updateIsCompanyName(inputValue);
    }
  };


  // Placeholder text based on number of selected options
  const selectedCount =
    isMulti && value && value.length > 0 ? `${value.length} selected !` : null;

  return (
    <div className="position-relative">
      {label && (
        <label
          htmlFor={name}
          style={labelStyle}
          className="custom-select-label"
        >
          {label}
          {required && " *"}
        </label>
      )}
      <Select
        ref={selectRef}
        options={options}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        styles={customStyles ? customStyles : defaultStyles}
        isMulti={isMulti}
        isSearchable={isSearchable}
        isClearable={isClearable}
        className="position-relative"
        defaultValue={defaultValue}
        components={{ MenuList: CustomMenuList }}
        onInputChange={handleInputChange}
        isDisabled={isDisabled}
        tabIndex={isDisabled ? -1 : 0}
      />
      {/* Show the count of selected values  */}
      {selectedCount && (
        <div className="selectedCountLabel">{selectedCount}</div>
      )}
      {isMulti && value && value.length > 0 && (
        <div className="multiSelectValueWrap">
          {value.map((val) => (
            <div key={val.value} className="multiSelectValue">
              {val.label}
              <span className="ms-2" onClick={() => handleRemove(val)}>
                <img src={closeIcon} alt="close" className="closeIcon" />
              </span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default CustomSelect;
